import {Routes} from 'constants/routes';

import {Navigate, RouteProps, useLocation} from 'react-router-dom';

const PrivateRoute = ({children}: RouteProps) => {
  const location = useLocation();

  const userJSON = localStorage.getItem('user');
  let user;

  if (userJSON) {
    user = JSON.parse(userJSON);
  }

  if (user) {
    const {attributes} = user;

    if (attributes.pubs.length === 0 && !attributes.admin) {
      return (
        <>
          <Navigate to={Routes.PROFILE} state={{from: location}} />
          {children}
        </>
      );
    }

    return <>{children}</>;
  }

  return (
    <>
      <Navigate to={Routes.LOGIN} state={{from: location}} />
      {children}
    </>
  );
};

export default PrivateRoute;
